import { useEffect, RefObject } from 'react'

export function useEscapeKey(
  element: RefObject<HTMLElement | null>,
  callback: () => void,
) {
  useEffect(() => {
    const elem = element.current

    const listenToEscKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        callback()
      }
    }

    elem?.addEventListener('keydown', listenToEscKey)

    return () => elem?.removeEventListener('keydown', listenToEscKey)
  }, [callback, element])
}
